<div class="goal">
    <div class="goal-container">
        <div class="goal-body">
            <div class="goal-icon-column">
                <img class="goal-icon" [src]="'/assets/images/icons/PM Goals/' + goal.name + ' - PM View Mode.png'" />
            </div>
            <div class="goal-column goal-column-name bold">{{goal.themeSubArea ? goal.name + ' - ' + goal.themeSubArea : goal.name}}</div>
            <div class="goal-column goal-column-metrics">
                <span class="bold">Target:&nbsp;</span>
                {{ !!getTargets() ? (getTargets() | number:'1.0-0') + ' ' + displayPreferredOutcomeMetricName() : '--'}}
            </div>
            <div class="goal-column goal-column-metrics">
                <span class="bold">Linked Progress:&nbsp;</span>
                {{calculateProgress() > 0 ? (calculateProgress() | number:'1.0-0') + ' ' + displayPreferredOutcomeMetricName() : '--'}}
            </div>
            <div class="charts goal-column" [ngClass]="getGoalClass(goal.name)">
                <div class="charts bar-container">
                    <div class="bar completed-progress-bar" [style.width.%]="calculateProgressPercentage()"></div>
                    <div class="bar remainder-progress-bar" [style.width.%]="calculateTargetPercentageRemaining()"></div>
                </div>
                <div class="graph-metric">{{!!getTargets() ? (calculateProgressPercentage() | number:'1.0-0') + '%' : '--%' }}</div>
            </div>
            @if (!isExpanded) {
            <div (click)="expandCloseGoal(goal, $event)" class="arrow"><i style="cursor: pointer" class="material-icons">arrow_drop_down</i></div>
            } @if (isExpanded) {
            <div (click)="expandCloseGoal(goal, $event)" class="arrow"><i style="cursor: pointer" class="material-icons">arrow_drop_up</i></div>
            }
        </div>
    </div>
    <div class="expansion-container-width">
        <mat-expansion-panel
            class="remove-mat-expansion-panel-padding mat-expansion-panel-body-color"
            [expanded]="isExpanded === true"
            (open)="expandCloseGoal()"
            hideToggle
        >
            <app-metric-charts [project]="project" [goal]="goal"></app-metric-charts>
            <app-linked-outcomes-panel [outcomeMetrics]="outcomeMetrics" [project]="project" [goal]="goal"></app-linked-outcomes-panel>
        </mat-expansion-panel>
    </div>
</div>
